import { jsx as _jsx } from "react/jsx-runtime";
import { Dashboard as UIDashboard } from "@bluframe/mightychroma-mightytool-ui";
const Dashboard = ({ isLoading, sections }) => (_jsx(UIDashboard, { isLoading: isLoading, sections: sections }));
export default Dashboard;
